import Trends from "./components/seo/Trends";
import { createComponentsPassagensPromocionais } from "./components/seo/passagens-promocionais";
import { createComponentsPassagensInternacionais } from "./components/seo/passagens-internacionais";
import { createComponentsFeriado } from "./components/seo/promocionais/feriado";
import { createComponentsDestinationToTravel } from "./components/seo/destination/destinationToTravel";
import { createComponentsDestination } from "./components/seo/destination/destino";
import { createComponentsFriday } from "./components/seo/promocionais/friday";
import { createComponentsCia } from "./components/seo/cia/cia";
import { createComponentsPassagemAerea } from "./components/seo/passagem-aerea";
import { createComponentsCareer } from "./components/career";
import "./components/PriceCalendar/App";

// Outras seções.
createComponentsPassagemAerea();
createComponentsPassagensPromocionais();
createComponentsPassagensInternacionais();
createComponentsDestination();
createComponentsCia();
createComponentsDestinationToTravel();
createComponentsFeriado("finados", "2020-10-30", "2020-11-03");
createComponentsFeriado("corpus-christi", "2020-06-11", "2020-06-14");
createComponentsFeriado("semana-santa-pascoa", "2020-04-18", "2020-04-22");
createComponentsFeriado("ano-novo", "2020-12-30", "2021-01-04");
createComponentsFeriado("carnaval", "2020-02-22", "2020-02-29");
createComponentsFeriado("dia-das-maes", "2020-05-08", "2020-05-11");
createComponentsFeriado("dia-do-trabalho", "2020-04-30", "2020-05-04");
createComponentsFeriado("dia-dos-namorados", "2020-06-10", "2020-06-15");
createComponentsFeriado("festa-junina", "2020-06-05", "2020-06-10");
createComponentsFeriado("independencia-do-brasil", "2020-09-05", "2020-09-10");
createComponentsFeriado("nossa-senhora-aparecida", "2020-10-09", "2020-10-14");
createComponentsFeriado("proclamacao-da-republica", "2020-11-14", "2020-11-18");
createComponentsFriday();
createComponentsCareer();

const setMobileCityEnvelope = () => {
	try {
		const envelopeForMobile = document.getElementById("envelope-for-mobile");
		if (window.outerWidth < 992) {
			const background = envelopeForMobile.attributes["data-mobile-background"].value;
			envelopeForMobile.style.backgroundImage = background;
			envelopeForMobile.style.backgroundSize = "cover";
		} else {
			envelopeForMobile.style.backgroundImage = "";
			envelopeForMobile.style.backgroundSize = "";
		}
	} catch (err) {
		console.error(err);
	}
};

if (document.body.classList.contains("destination-page")) {
	setMobileCityEnvelope();
	window.onresize = setMobileCityEnvelope;
}
